import { capsulas, Capsula } from "@/data/capsulas";
import { blogPosts, BlogPost } from "@/data/blogPosts";

export const getCapsulasByPostId = (postId: string): Capsula[] => {
  return capsulas.filter(capsula => 
    capsula.relatedPostIds.includes(postId)
  );
};

// Obtener todos los artículos de la misma herramienta
export const getArticlesByTool = (toolName: string): BlogPost[] => {
  return blogPosts.filter(post => 
    post.tools?.some(tool => 
      tool.toLowerCase().includes(toolName.toLowerCase())
    )
  );
};

// Obtener la herramienta principal del artículo
export const getPrimaryTool = (post: BlogPost): string | null => {
  return post.tools?.[0] || null;
};

// Obtener todos los posts que pertenecen a un capsulaTheme específico
export const getPostsByCapsulaTheme = (themeId: string): BlogPost[] => {
  return blogPosts.filter(post => post.capsulaTheme === themeId);
};
